// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lazy[data-v-312645a6]{will-change:transform}.blur[data-v-312645a6]{filter:blur(2px)}.gallery-grid-photo-wrapper[data-v-312645a6]{width:100%;height:100%;position:absolute;top:0}.gallery-grid-photo-wrapper picture[data-v-312645a6]{display:flex}.gallery-grid-photo-wrapper picture img[data-v-312645a6]{-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
